import { wire } from 'hyperhtml';
import { ChangeEvent } from 'react';

interface TeacherInfo {
  id: number;
  displayNameZh: string;
  profileImageUrlSquare: string;
  isInactive: boolean;
}

interface TeachersSelectParams {
  teachers: TeacherInfo[];
  target: string;
  selectedId: number;
  name: string;
  onChange: (evt: ChangeEvent<HTMLSelectElement>) => any;
  includeEmpty?: boolean;
}

export default ({ teachers, target, selectedId, name, onChange, includeEmpty = false }: TeachersSelectParams) => {
  const options = [];
  if (includeEmpty) {
    options.push(wire()`
      <option selected=${!selectedId} value="__None">None</option>
    `);
  }
  teachers.forEach((teacher) => {
    // I'm sorry, I don't know how to
    // do this more elegantly PC 2020-05-24
    if (teacher.isInactive) {
      const enhancedHtml = `
        <span class='teacher_select_option'>
          <span class='photo_thumb teacher_photo'>
            <img src=${teacher.profileImageUrlSquare} />
          </span>
          ${teacher.displayNameZh} (Inactive)
        </span>
      `;
      options.push(wire()`
        <option selected=${teacher.id === selectedId} value=${teacher.id} data-content="${enhancedHtml}">
          ${teacher.displayNameZh} (Inactive)
        </option>
      `);
    } else {
      const enhancedHtml = `
        <span class='teacher_select_option'>
          <span class='photo_thumb teacher_photo'>
            <img src=${teacher.profileImageUrlSquare} />
          </span>
          ${teacher.displayNameZh}
        </span>
      `;
      options.push(wire()`
        <option selected=${teacher.id === selectedId} value=${teacher.id} data-content="${enhancedHtml}">
          ${teacher.displayNameZh}
        </option>
      `);
    }
  });
  return wire()`
    <select
      class="selectpicker"
      data-target=${target}
      name=${name}
      data-style="btn-outline"
      data-menu-style="dropdown-blue"
      onChange=${onChange}
    >
      ${options}
    </select>
  `;
};
